<template>
  <div class="menubar-container">
    <div class="menubar" :class="{ 'border-0': withoutBorder, 'content-menubar': contentMenubar }">
      <div class="leftItems" v-if="slotLeft" :class="[{ 'flex-nowrap': leftNowrap }, leftItemClass]">
        <slot name="leftItems"></slot>
      </div>
      <div class="centerItems" v-if="slotCenter" :class="[{ 'flex-nowrap': centerNowrap }, centerItemClass]">
        <slot name="centerItems"></slot>
      </div>
      <div class="rightItems" v-if="slotRight" :class="[{ 'flex-nowrap': rightNowrap }, rightItemClass]">
        <slot name="rightItems"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSlots } from "vue";

defineProps<{
  leftItemClass?: string;
  centerItemClass?: string;
  rightItemClass?: string;
  leftNowrap?: boolean;
  centerNowrap?: boolean;
  rightNowrap?: boolean;
  withoutBorder?: boolean;
  contentMenubar?: boolean;
}>();

const slots = useSlots();

const slotRight = computed(() => {
  return !!slots["rightItems"];
});
const slotCenter = computed(() => {
  return !!slots["centerItems"];
});
const slotLeft = computed(() => {
  return !!slots["leftItems"];
});
</script>
